(function () {
  class FreeSpinsOutroNoWin extends PIXI.Container {
    constructor() {
      super();

      this.visible = false;
      this._fromNumFreeSpinsText = undefined;
      this._panel = undefined;
      this._darkOverlay = undefined;
      this._pressStartBox = undefined;
    }

    initialise() {
      messageBus.subscribe('spinner:GameConfigEvent', () => {
        this.onLayoutComplete();
      });
    }

    onLayoutComplete() {
      this._fromNumFreeSpinsText = resourceManager.get(
        'freeSpinsOutroNoWinContainer:FreeSpinsOutroNoWin:panel:fromNumFreeSpinsText'
      );
      this._panel = resourceManager.get('freeSpinsOutroNoWinContainer:FreeSpinsOutroNoWin:panel');
      this._darkOverlay = resourceManager.get('freeSpinsOutroNoWinContainer:FreeSpinsOutroNoWin:darkOverlay');
      this._pressStartBox = resourceManager.get('freeSpinsOutroNoWinContainer:FreeSpinsOutroNoWin:pressStartColourBox');
      this._darkOverlay.interactive = true; // stop being able to click on anything behind the panel
      this._pressStartBox.interactive = false;
    }

    async show(numFS, winAmount) {
      this._fromNumFreeSpinsText.setTranslationParameters(numFS);
      this.visible = true;
      this._pressStartBox.interactive = false;

      await game.tweenFromToAsync(
        this._panel.scale,
        {
          x: 0,
          y: 0,
        },
        {
          x: 1,
          y: 1,
          duration: 0.5,
          ease: 'bounce.out',
        }
      );

      let waitForInteractionResolver = null;
      const waitForInteractionPromise = new Promise((resolve) => {
        waitForInteractionResolver = resolve;
      });

      const pressedCB = () => {
        game.stopAutoClickForReplayRewatch();
        if (this._pressStartBox.interactive === true) {
          this._pressStartBox.interactive = false;
          waitForInteractionResolver();
        }
      };

      this._pressStartBox.mousedown = this._pressStartBox.touchstart = pressedCB;

      this._pressStartBox.interactive = true;
      game.autoClickForReplayRewatch(pressedCB);
      await waitForInteractionPromise;

      this._pressStartBox.interactive = false;
      this._pressStartBox.mousedown = this._pressStartBox.touchstart = undefined;

      await game.tweenFromToAsync(
        this._panel.scale,
        {
          x: 1,
          y: 1,
        },
        {
          x: 0,
          y: 0,
          duration: 0.15,
          ease: 'none',
        }
      );

      this.visible = false;
    }
  }

  let create = function (json) {
    return new FreeSpinsOutroNoWin();
  };

  let initialise = function (json, container, resources) {
    container.initialise();
  };

  let getFilesRequired = function () {
    return [];
  };

  resourceManager.registerObjectType('FreeSpinsOutroNoWin', create, initialise, getFilesRequired);
})();
